import { BorderColorOutlined } from "@mui/icons-material";
import React from 'react'
import { Button, Form, InputGroup, OverlayTrigger, Tooltip } from "react-bootstrap";

const DefaultInput = ({ name, value, handleChange, handleBlur, placeholder, isInvalid, error }) => {
  return (
    <>
    <InputGroup>
      <Form.Control
        name={name}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder={placeholder}
        value={value}
        spellCheck={false}
        isInvalid={isInvalid}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
          }
        }}
      />
      <InputGroup.Text className="p-0 border-start-0 editIcon z-0">
        <OverlayTrigger placement="right" delay={{ show: 250, hide: 400 }} overlay={<Tooltip id="button-tooltip">This is a default value</Tooltip>}>
          <Button variant="light" className="bg-white border-0">
            <BorderColorOutlined />
          </Button>
        </OverlayTrigger>
      </InputGroup.Text>
    </InputGroup>
    <Form.Control.Feedback type="invalid">
      {error}
    </Form.Control.Feedback>
  </>
  )
}

export default DefaultInput
